import { useMutation } from '@tanstack/react-query';

import { $apiV2, errorHandler } from 'modules/global';

export const useLeadSend = () =>
  useMutation({
    mutationFn: async (data: { ticket_id?: number; learning_center_id?: number; name?: string; phone?: string }) => {
      const res = await $apiV2.post('/lead/send', data);

      return res.data;
    },
    onError: errorHandler()
  });
